// @flow
import segmentationActions from '../actions/segmentation';

export const FILTER_BAR_DROPDOWN_BREAKPOINT = 888;

type ViewportSizeChangeAction = {
    payload: {width: number}
};

export default function toggleFilterBarDropdownVisiblity(
    store: Object,
    {payload: {width}}: ViewportSizeChangeAction
) {
    const hasEnoughSpaceInFilterBar = store.getState().segmentation
        .hasEnoughSpaceInFilterBar;

    if (width <= FILTER_BAR_DROPDOWN_BREAKPOINT && hasEnoughSpaceInFilterBar) {
        store.dispatch(segmentationActions.toggleDropdownVisibility(false));
    }

    if (width > FILTER_BAR_DROPDOWN_BREAKPOINT && !hasEnoughSpaceInFilterBar) {
        store.dispatch(segmentationActions.toggleDropdownVisibility(true));
    }
}
